// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DoubleDigitCountBubble-cls1__db0a5fff3281c6a6b483{/*!*/}.DoubleDigitCountBubble-cls2___94e02734cc4166b8317{box-sizing:content-box;border-radius:50%;background:#bb0202;color:#fff;border:1.62px solid #fff;font-size:10px;font-weight:500;text-align:center;width:18px;height:18px;line-height:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "DoubleDigitCountBubble-cls1__db0a5fff3281c6a6b483",
	"cls2": "DoubleDigitCountBubble-cls2___94e02734cc4166b8317 DoubleDigitCountBubble-cls1__db0a5fff3281c6a6b483"
};
export default ___CSS_LOADER_EXPORT___;
